import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            position: 'relative',
            backgroundColor: theme.palette.ui07,
            borderRadius: '16px',
            width: '32px',
            height: '16px',
            border: 0,
            outline: 0,
            cursor: 'pointer',
            transition: '.3s',
            display: 'inline-block',
            '&.disabled': {
                backgroundColor: theme.palette.disableSwitchBackgournd,
                cursor: 'default',
                '& .toggle': {
                    backgroundColor: theme.palette.disableSwitchButton
                },
                '& input': {
                    cursor: 'default'
                }
            },
            '&.is-mobile': {
                height: '32px',
                width: '50px',
                borderRadius: '32px'
            },
            '&:hover': {
                '& .toggleBackground': {
                    display: 'block',
                    backgroundColor: theme.palette.default00 + '04',
                    '&.toggleOn': {
                        backgroundColor: theme.palette.primary10 + '04',
                        left: 'unset',
                        right: '-12px'
                    }
                }
            },
            '&:focus': {
                '& .toggleBackground': {
                    display: 'block',
                    backgroundColor: theme.palette.default00 + '12',
                    '&.toggleOn': {
                        backgroundColor: theme.palette.primary10 + '12',
                        left: 'unset',
                        right: '-12px'
                    }
                }
            },
            '&:active': {
                '& .toggleBackground': {
                    display: 'block',
                    backgroundColor: theme.palette.default00 + '10',
                    '&.toggleOn': {
                        backgroundColor: theme.palette.primary10 + '12',
                        left: 'unset',
                        right: '-12px'
                    }
                }
            }
        },
        containerOn: {
            backgroundColor: theme.palette.primary10
        },
        toggle: {
            width: '12px',
            height: '12px',
            position: 'absolute',
            zIndex: 5,
            top: '2px',
            left: '2px',
            backgroundColor: theme.palette.ui10,
            borderRadius: '100%',
            transition: '.3s',
            '&.is-mobile': {
                width: '24px',
                height: '24px'
            },
            '&.toggleBackground': {
                width: '36px',
                height: '36px',
                top: '-10px',
                left: '-10px',
                display: 'none',
                zIndex: 4
            }
        },
        toggleOn: {
            left: '18px',
            '&.toggleBackground': {
                left: 'unset',
                right: '-12px',
            },
            '&.is-mobile': {
                left: '22px'
            }
        },
        checkbox: {
            position: 'absolute',
            zIndex: 10,
            cursor: 'pointer',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            opacity: 0,
            '&.focus-visible + .toggle-checkbox-ring': {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.focus01}`
            }
        },
        checkboxRing: {
            position: 'absolute',
            pointerEvents: 'none',
            zIndex: 6,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            borderRadius: '12px',
            '&.is-mobile': {
                borderRadius: '32px'
            }
        }
    };
});
const Switch = ({ className, id, checked, disabled, onChange }) => {
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    // const change = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    //     onChange(e.target.checked);
    // }, []);
    const change = (e) => {
        onChange(e.target.checked);
    };
    return (React.createElement("span", { className: cx('toggle-container', styles.container, checked && styles.containerOn, isMobile && 'is-mobile', disabled && 'disabled', className) },
        React.createElement("input", { type: 'checkbox', ...(id ? { id } : {}), checked: checked, className: styles.checkbox, disabled: disabled, onChange: change }),
        React.createElement("div", { className: cx('toggle-checkbox-ring', styles.checkboxRing, isMobile && 'is-mobile') }),
        React.createElement("div", { className: cx('toggle', styles.toggle, checked && styles.toggleOn, isMobile && 'is-mobile') }),
        React.createElement("div", { className: cx('toggle toggleBackground', styles.toggle, checked && 'toggleOn', isMobile && 'is-mobile') })));
};
export default Switch;
